import React, { useState } from 'react'
import { getApiHeader } from 'utlis/commonfunctions';
import axios from 'axios'
import Payment from './Components/Payment'
import YourTelsimSim from './Components/YourTelsim'
import Plans from './Components/Plan/Plans'
import { Box, Button, TextField, Typography, Grid, Card, CardActionArea, Backdrop, CircularProgress } from '@mui/material';
import Alert from '@mui/material/Alert';
import swal from 'sweetalert';



const SERVER_URL = process.env.REACT_APP_API_URL;
function PrepaidRecharge() {
  const rechargeSessionId = sessionStorage.getItem("rechargeSessionId")
  const [step, setStep] = useState(1);


  // step one states  start here.
  const [planData, setPlanData] = useState([])
  const [disable, setDisable] = useState(true)
  const [disableMethod, setEnableRechargeMethod] = useState(false)
  const [isCreaditPlan, setIsCreaditPlan] = useState(false)
  const [planCredits, setPlanCredits] = useState([])
  const [selectedPrepaidPlanId, setSelectedPrepaidPlanId] = useState("")
  const [plansDisable, setPlansDisable] = useState(true)
  const [loading, setLoading] = useState(false);
  const[rechargeType,setRechargeType]=useState("")
 const[rechargeData,setRechargeData]=useState("")
 const [open, setOpen] = useState(false);

   let type

  const handleStepOne = async () => {
    try {
      setStepOneLoading(true)

      const headers = await getApiHeader()
      const response = await axios.post(`${SERVER_URL}prepaid-recharge/recharge-type-check`, stepOneformData, {
        headers: headers
      })

      if (response.status === 200) {
        setEnableRechargeMethod(true)
        setPlanData(response.data.data.plans)
        setDisable(false)
        sessionStorage.setItem('rechargeSessionId', response.data.data.session_id);

        setStep((prevStep) => prevStep + 1);
        setStepOneLoading(false)
        setIsCreaditPlan(response.data.data.is_sim_credit_plan ? true : false)
        setPlanCredits(response.data.data.plan_credit)
        setDisable(true)


      } else {
        stepOnerror(true)
        setDisable(true)
      }
    } catch (error) {
      console.log("error in catch", error.response?.data.message)
      setStepOneLoading(false)
      setStepOneError(error.response?.data.message)
      setDisable(true)
      console.log("stepone error", error)

    }
  }




  const handleStepThreeApi = async () => {
    try {
      const headers = await getApiHeader()
      const stepThreeData = {
        session_id: rechargeSessionId,
        plan_id: selectedPrepaidPlanId
      }

      const response = await axios.post(`${SERVER_URL}prepaid-recharge/recharge-select-plan`, stepThreeData, { headers: headers })
      if (response.status == 200) {
        setRechargeData(response.data.data)
        type=response.data.data.recharge_type
        setRechargeType(type)
        if (response.data.data.recharge_type === "RechargeWithVoucher" || response.data.data.recharge_type === "Free-IDD-Recharge") {
         await handleFinalStep()
          return
        } else {
          setStep((prevStep) => prevStep + 1)
        }
      }
    } catch (error) {
    }
  }




  const handleFinalStep = async () => {
    setLoading(true)
    setOpen(false)
    try {
      const paymentData = {
        session_id: rechargeSessionId,
        plan_id: selectedPrepaidPlanId,
        recharge_type:type,
      }
      const headers = await getApiHeader();
      const response = await axios.post(`${SERVER_URL}prepaid-recharge/recharge`, paymentData, { headers });
      if (response.status === 200) {
        setLoading(false)
      }

      const message=response.data.message
      if(message){
      swal("Success",message).then(() => {
        setStep(1)});
      }

    } catch (error) {
      const message = error?.response?.data?.message;
      if (message) {
        swal("Error", message).then(() => {
          setStep(1)});
        }
    }
    finally {
      setLoading(false);
    }
  };





  const handleStepone = () => {
    setStep((prevStep) => prevStep + 1);
  }

  const handleStepTwo = () => {
    handleStepThreeApi()
  }


  




  const getPlanData = (input, e) => {
    setPlanData(input)
  }

  const getplanCredits = (input, e) => {
    setPlanCredits(input)
  }

  const getIsCreditPlan = (input, e) => {
    setIsCreaditPlan(input)
  }


  const getDisable = (input, e) => {
    setPlansDisable(input)
  }


 const getFinalStep=(input,e)=>{
    setStep(input)

 }


 const handleBoxclose=(input,e)=>{
  setOpen(input)
 }








  // Function to handle API calls
  const handleStepApi = async () => {
    try {
      if (step === 1) {
        handleStepone()
      } else if (step === 2) {
        handleStepTwo()
      } else if (step === 3) {
        // handleStepThree()
      }
    } catch (err) {
      console.log(err)
      // setError('Error occurred while making API call.');
    } finally {
      // setLoading(false);
    }
  };




  const nextStep = async (event) => {
    if (event) {
      event.preventDefault();
    }

    await handleStepApi();
  };

  const prevStep = (event) => {
    event.preventDefault()
    setStep((prevStep) => prevStep - 1);
  };




  //  const nextStep = () =>{setStep((prevStep) => prevStep + 1)} 
  //  const prevStep = () => setStep((prevStep) => prevStep - 1);


  return (
    <div>

      {loading && (
        <Backdrop
          open={true}
          style={{
            color: "#fff",
            zIndex: 9999,
          }}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <div>
        {step === 1 && <YourTelsimSim nextStep={nextStep} prevStep={prevStep} stepCount={step} setPlanData={getPlanData} setplanCredits={getplanCredits} setIsCreaditPlan={getIsCreditPlan} />}
        {step === 2 && <Plans nextStep={nextStep} prevStep={prevStep} stepCount={step} planData={planData} setPlanData={setPlanData} isCreaditPlan={isCreaditPlan} planCredits={planCredits} selectedPrepaidPlanId={selectedPrepaidPlanId} setSelectedPrepaidPlanId={setSelectedPrepaidPlanId} disabled={plansDisable} setDisable={getDisable}   handleBoxclose={handleBoxclose}  open={open}/>}
        {step === 3 && <Payment nextStep={nextStep} prevStep={prevStep} selectedPrepaidPlanId={selectedPrepaidPlanId} rechargeType={rechargeType}  rechargeData={rechargeData} getFinalStep={getFinalStep}/>}
      </div>
    </div>
  );
}

export default PrepaidRecharge;
